<template>
  <v-card class="elevation-12 border-0">
    <v-col cols="12" class="pa-4">
      <v-img
        :src="$vuetify.theme.dark ? require('@/assets/images/logo_dinamo_high_light.png') : require('@/assets/images/logo_dinamo_high_dark.png')"
      />
    </v-col>
    <v-card-text>
      <v-form @submit.prevent="submit">
        <p>{{ $t('you_need_to_change_password') }}</p>
        <v-alert
          :value="true"
          color="info"
          icon="info"
          outline
        >
          {{ $t('verify_password_policy') }}
        </v-alert>
        <v-text-field
          prepend-icon="person"
          :label="$tc('username')"
          type="text"
          disabled
          :value="username"
        />

        <v-text-field
          id="RenewPasswordPage_password"
          prepend-icon="lock"
          :label="$tc('new_password')"
          :hint="$tc('new_password_hint')"
          type="password"
          v-model="password"
          counter
          :error-messages="passwordErrors"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
        />
        <v-text-field
          id="RenewPasswordPage_repeatPassword"
          prepend-icon="lock"
          :label="$tc('repeat_password')"
          type="password"
          v-model="repeatPassword"
          counter
          :error-messages="repeatPasswordErrors"
          @input="$v.repeatPassword.$touch()"
          @blur="$v.repeatPassword.$touch()"
        />
        <v-row class="my-2" no-gutters>
          <v-spacer />
          <v-btn
            id="RenewPasswordPage_submit"
            type="submit"
            :disabled="$v.$invalid"
            :dark="!$v.$invalid"
          >
            {{ $t('renew') }}
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  sameAs
} from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      repeatPassword: null
    }
  },
  computed: {
    username () {
      return this.$store.state.auth.username
    },
    password: {
      get () {
        return this.$store.state.auth.password
      },
      set (val) {
        return this.$store.commit('auth/SET_PASSWORD', val)
      }
    },
    error () {
      // return this.$v.$anyError
      return this.$store.state.auth.error.status
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push(
          this.$t('$validation.min_length', {
            num: this.$v.password.$params.minLength.min
          })
        )
      !this.$v.password.maxLength &&
        errors.push(
          this.$t('$validation.max_length', {
            num: this.$v.password.$params.maxLength.max
          })
        )
      !this.$v.password.required && errors.push(this.$t('$validation.required'))
      return errors
    },
    repeatPasswordErrors () {
      const errors = []
      if (!this.$v.repeatPassword.$dirty) return errors
      !this.$v.repeatPassword.sameAs &&
        errors.push(this.$t('$validation.same_as'))
      !this.$v.repeatPassword.required &&
        errors.push(this.$t('$validation.required'))
      return errors
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(16)
    },
    repeatPassword: {
      required,
      sameAs: sameAs('password')
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      const isValid = !this.$v.$invalid

      if (isValid) {
        this.$store
          .dispatch('auth/doChangePassword')
          .then(() => {
            this.clearForm()
            this.$store
              .dispatch('auth/doLogout')
              .then(() => this.$router.push({ name: 'login' }))
          })
          .catch(err => {
            this.clearForm()
            const errObj = this.$store.getters['error/getErrorObj'](err)
            if (errObj) {
              this.$notify.hsmError(errObj, err)
            } else {
              this.$notify.error({ message: err })
            }
          })
      }
    },
    clearForm () {
      this.password = null
      this.repeatPassword = null
      this.$v.$reset()
    }
  },
  watch: {
    error (val) {
      if (val) {
        this.$notify.error({ message: val })
      }
    }
  }
}
</script>
